<template>
	<div>
		<div class="fx-header" style="min-width:1092px">
			<p>客户档案</p>
		</div>
		<div class='container'>
			<div class="left-box">
				<div class="fx-title1">
					<p>客户类别</p>
				</div>
				<div class="tree-box">
					<div class="btn-box">
						<el-button v-if="AuthorityList['03_0001_0004_00']" type="primary" plain size='small' @click="addClick">新 建</el-button>
						<el-button v-if="AuthorityList['03_0001_0002_00']" type="primary" :disabled="isDisable" @click="editClick" plain size='small'>修 改</el-button>
						<el-button v-if="AuthorityList['03_0001_0006_00']" type="primary" :disabled="isDisable" @click="deleteClick" plain size='small'>删 除</el-button>
					</div>
					<div style="height:90%">
						<el-tree ref="tree" node-key="ccid" :data="data" :draggable="AuthorityList['03_0001_0002_00']" :allow-drop="allowDrop" @node-drop="handleDrop" :highlight-current='true' :default-expand-all='true' class="tree" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
					</div>
				</div>
			</div>
			<div class="right-box">
				<div class="fx-title1">
					<p>客户列表</p>
				</div>
				<div class="table-box">
					<tableBox :id='id'></tableBox>
				</div>
			</div>
			<el-dialog title="客户分类" class="dialog-title" :visible.sync="addModal" :before-close="cancelClick" width='350px' :close-on-click-modal="false">
				<span style="color: #F56C6C">*</span>
				<span>分类名称：
					<el-input @blur='nameChange' class="name-input" v-model="name" placeholder="请输入名称" size='mini' :maxlength='10'></el-input>
				</span>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" class="fx-big-btn"  @click="cancelClick">取 消</el-button>
					<el-button size="mini" type="primary" class="fx-big-btn"  @click="saveClick">保 存</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import tableBox from '@/components/customer/tableBox.vue'
export default {
	name: 'customer',
	components: {
		tableBox
	},

	data () {
		return {
			isEdit: false,
			isDisable: true,
			id: '-1',
			name: '',
			dataName: '',
			data: [],
			addModal: false,
			AuthorityList: {
				'03_0001_0001_00': false,
				'03_0001_0002_00': false,
				'03_0001_0003_00': false,
				'03_0001_0004_00': false,
				'03_0001_0005_00': false,
				'03_0001_0006_00': false,
				'03_0001_0007_00': false,
				'03_0001_0008_00': false,
				'03_0001_0009_00': false,
				'03_0001_0010_00': false,
				'03_0001_0011_00': false
			},
			defaultProps: {
				children: 'childNode',
				label: 'ccname'
			},
			fxDataVerification: this.$fxUtils.fxDataVerification()
		}
	},
	created () {
		this.getAuthority('03_0001_0000_00')
		this.getTreeData()
	},
	methods: {
		// 排序
		allowDrop (draggingNode, dropNode, type) {
			// console.log(draggingNode, dropNode, type)
			if (draggingNode.level === dropNode.level) {
				return type === 'prev' || type === 'next'
			} else {
				// 不同级进行处理
				return false
			}
		},
		handleDrop (draggingNode, dropNode, dropType, ev) {
			let idList = this.data[0].childNode.map(item => {
				return item.ccid
			})
			let params = idList
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/sortCategory`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg)
				}
			})
		},
		nameChange () {
			var reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g
			var res = this.name.replace(reg, '')
			this.name = res
			// console.log(this.name)
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		editClick () {
			this.name = this.dataName
			this.isEdit = true
			this.addModal = true
		},
		deleteClick () {
			this.$confirm('确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: this.id
				}
				// console.log(this.dataName)
				const logger = this.$fxLogger.createInfo('custom.custom-file.delete', { name: this.dataName })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/remove`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.id = ''
						this.isDisable = true
						this.getTreeData()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		addClick () {
			this.name = ''
			this.addModal = true
		},
		saveClick () {
			if (this.name === '' || this.name === ' ') {
				this.$message.error('请输入客户分类名称！')
			} else {
				if (this.isEdit) {
					let params = {
						name: this.name,
						id: this.id
					}
					let changeData = {
						pre: { name: this.dataName },
						cur: { name: this.name }
					}
					const logger = this.$fxLogger.createInfo('custom.custom-file.update', changeData)
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/update`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.$message.success('保存成功！')
							this.addModal = false
							this.name = ''
							this.id = ''
							this.isDisable = true
							this.isEdit = false
							this.getTreeData()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				} else {
					let params = {
						name: this.name
					}
					const logger = this.$fxLogger.createInfo('custom.custom-file.add', { name: this.name })
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/add`,
						data: params,
						logger
					}).then(res => {
						if (res.result) {
							this.$message.success('保存成功！')
							this.addModal = false
							this.name = ''
							this.isDisable = true
							this.getTreeData()
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						this.$message.error(err.msg)
					})
				}
			}
		},
		cancelClick () {
			this.name = ''
			this.addModal = false
		},
		getTreeData () {
			this.data = []
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.data.push(res.data)
					this.$nextTick(() => {
						let a = window.sessionStorage.getItem('customerSelect')
						if (a) {
							let data = JSON.parse(a)
							this.$refs.tree.setCurrentKey(data.customercategoryid)
							this.id = data.customercategoryid
						}
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		handleNodeClick (data) {
			this.dataName = data.ccname
			this.id = data.ccid
			if (data.defaultflag === true) {
				this.isDisable = true
				return false
			}

			if (this.id !== '' && this.id !== '-1') {
				this.isDisable = false
			} else {
				this.id = '-1'
				this.isDisable = true
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.container{
    height : calc(100%- 75px)
	display: flex;
	width:100%;
	flex-direction:row;
    .fx-title1{
        line-height 20px
        font-size 15px
        text-align left
        padding-left 8px
        padding 20px 0px 20px 0px
        p{
            border-left 4px solid var(--fx-primary-color)
            padding-left 10px
        }
    }
    .right-box{
        width : calc(100% - 280px);
        min-width :800px;
        height : calc(100% - 20px);
        padding 0px 10px 10px 10px
        border :1px solid #dce2fd
        border-top: none
        border-left: none
        .table-box{
            width :100%;
            height : calc(100% - 60px);
            border-top :1px solid #dce2fd
        }
    }
    .left-box{
        width :250px;
        min-width :250px;
        height : calc(100% - 20px);
        padding 0px 10px 10px 10px
        border :1px solid #dce2fd
        border-top: none
        .tree-box{
            width :100%;
            height : calc(100% - 60px);
            border-top :1px solid #dce2fd
            .btn-box{
                margin-top 10px
            }
            .tree{
                height : 90%;
                overflow-y :auto
                margin-top :10px
            }
        }
    }
}
</style>
<style lang="stylus">
.container {
    .dialog-footer{
		text-align: center
	}
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
        .name-input{
            width :150px
        }
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
